import { formatMass, type ReasonCode, type Unit } from '@repwise/domain';

/** Reason chips (ui_ux spec 02 §C6). */
export function reasonChip(reason: ReasonCode, increment?: number): string {
  switch (reason) {
    case 'INC_SUCCESS':
      return increment ? `+${formatMass(increment)} kg` : 'Up';
    case 'ROUNDED':
    case 'ROUNDED_UP':
      return 'Rounded';
    case 'NEED_SMALLER_PLATES':
      return 'Add smaller plates';
    case 'REPEAT_MISS':
    case 'REPEAT_LIGHTER':
      return 'Lighter last time';
    case 'REPEAT_SKIPPED':
      return 'Repeat';
    case 'DELOAD_OFFER':
      return 'Deload offered';
    case 'DELOAD_DONE':
      return 'Deload';
    case 'DELOAD_DECLINED':
      return 'Repeat';
    case 'RETURN_BREAK':
      return 'Welcome back';
    case 'MANUAL':
      return 'Set by you';
    case 'FIRST':
      return 'Starting weight';
  }
}

/** A weight with its unit. Always pass the unit the weight was recorded in (ADR-0018), never assume kg. */
export const wt = (m: number | null | undefined, unit: Unit) => (m === null || m === undefined ? '' : `${formatMass(m)} ${unit}`);

/** For screen readers: "82.5 kilograms". */
export const spokenWt = (m: number, unit: Unit) => `${formatMass(m)} ${unit === 'kg' ? 'kilograms' : 'pounds'}`;

export const mmss = (s: number) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;

export function sideText(plates: readonly number[]): string {
  return plates.length ? plates.map(formatMass).join(' + ') : 'just the bar';
}
